<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Preface">Preface</a></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction: A World of Whaling</a></p>
<p class="toc1"><a href="#/Chapter1">1. Community Ventures, Risks and Rewards </a></p>
<p class="toc"><span href="#/Chapter2" title="Link target outside of Sample">2. Mainers </span></p>
<p class="toc"><span href="#/Chapter3" title="Link target outside of Sample">3. Start of an Era </span></p>
<p class="toc"><span href="#/Chapter4" title="Link target outside of Sample">4. Golden Age </span></p>
<p class="toc"><span href="#/Chapter5" title="Link target outside of Sample">5. Civil War </span></p>
<p class="toc"><span href="#/Chapter6" title="Link target outside of Sample">6. End of an Era </span></p>
<p class="toc"><span href="#/Chapter7" title="Link target outside of Sample">7. Finis </span></p>
<p class="toc1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?78fa850e